export default {
  en: {
    languageName: "English",
    students: "Students",
    dashboard: "Dashboard",
    settings: "Settings",
    logout: "Logout",
    login: "Login",
    email: "Email",
    signIn: "Sign in",
    signingIn: "Signing in",
    search: "Search",
    password: "Password",
    showPassword: "Show password",
    hidePassword: "Hide password",
    authBackToSignIn: "Back",
    authConfirmTotp: "Two-factor authentication",
    authCode: "Code",
    authCodeRequired: "Please, enter a code from authentication app",
    authIncorrectCredentials: "Incorrect username or password.",
    authMessages: {
      "An account with the given email already exists.":
        "An account with the given email already exists.",
      "Confirm a Code": "Confirm a Code",
      "Confirm Sign In": "Confirm Sign In",
      "Create account": "Create account",
      "Enter your password": "Enter your password",
      "Forgot Password": "Forgot Password",
      "Have an account? ": "Have an account? ",
      "Invalid password format": "Invalid password format",
      "Invalid phone number format": "Invalid phone number format",
      "Loading...": "Loading...",
      "Lost your code? ": "Lost your code? ",
      "Network error": "Network error",
      "New Password": "New Password",
      "No account? ": "No account? ",
      "Resend a Code": "Resend a Code",
      "Reset password": "Reset password",
      "Sign In with AWS": "Sign In with AWS",
      "Sign Out": "Sign Out",
      "Sign Up": "Sign Up",
      "User already exists": "User already exists",
      "User does not exist": "User does not exist",
      "Username cannot be empty": "Username cannot be empty",
      "Username/client id combination not found.":
        "Username/client id combination not found.",
      "It may take a minute to arrive.": "It may take a minute to arrive.",
      "Your passwords must match": "Your passwords must match",
      "Dismiss alert": "Dismiss alert",
      Submitting: "Submitting",
      "Sign in to your account": "Sign in to your account",
    },
    notifications: "Notifications",
    allStudents: "All students",
    sortBy: "Sort by",
    universityName: "University name",
    skills: "Skills",
    MajorYouAppliedFor: "Major you applied for",
    activeFilters: "Active filters",
    clearAll: "Clear all",
    clear: "Clear",
    new: "New",
    invited: "Invited",
    rejected: "Rejected",
    itemsSelected: "items selected",
    invite: "Invite",
    shortlist: "Shortlist",
    reject: "Reject",
    student: "Student",
    addToShortlist: "Add to shortlist",
    education: "Education",
    workPreferences: "Work preferences",
    languages: "Languages",
    personalityTraits: "Personality traits",
    isTheMaximumScore: "is the maximum score",
    meaningOfTheTest: "Meaning of the test",
    toolsAndSkills: "Tools & Skills",
    advancedness: "Proficiency",
    workExperience: "Relevant work experience",
    less: "Less",
    more: "More",
    vacancies: "My major vacancies",
    department: "Department",
    status: "Status",
    applied: "Applied",
    studentsApplied: "Applied",
    draft: "Draft",
    closed: "Closed",
    published: "Published",
    reverse: "Reverse",
    rejectStudent: "Reject student",
    chooseTemplate: "Choose template",
    title: "Title",
    message: "Message",
    close: "Close",
    open: "Open",
    save: "Save",
    sendMessage: "Send message",
    optional: "Optional",
    cc: "CC",
    fieldRequired: "This field is required",
    MajorParameters: "Major parameters",
    positionName: "Position name",
    firmName: "Firm name",
    salary: "Salary (in PLN)",
    perYear: "Per year",
    perMonth: "Per month",
    brutto: "Gross",
    netto: "Net",
    workType: "Work type",
    fullTime: "Full-time",
    partTime: "Part-time",
    fulltime: "Full-time",
    parttime: "Part-time",
    "fulltime,parttime": "Full-time, part-time",
    "parttime,fulltime": "Part-time, full-time",
    office: "Office",
    remote: "Remote",
    dontShowSalary: "Don't show salary",
    MajorDescription: "Major description",
    aboutUs: "About us",
    description: "Description",
    weOffer: "We offer",
    studentRequirements: "Student requirements",
    addLanguage: "Add language",
    skillsAndTech: "Skills & Tech",
    enterSkill: "Enter skill",
    requirements: "Requirements",
    post: "Post",
    enterCity: "Enter city",
    helpSkills: "Enter required skills and/or tools",
    publish: "Publish",
    delete: "Delete",
    cancel: "Cancel",
    deleteConfirmation: "Are you sure you want to delete these items?",
    selected: "selected",
    undoAlert: "You won't be able to undo this",
    clearConfirmation: "Are you sure you want to clear the form?",
    wrongCredentials: "Login or password is incorrect",
    defaultErrorMessage: "An error occurred. Please try again later.",
    personalInfo: "Personal info",
    firstName: "First name",
    companyName: "Company name",
    recoverPassword: "Recover password",
    recoverPasswordMessage:
      "Please tell us your e-mail so we can send you a recovery link if your account exists",
    yourEmail: "Your e-mail",
    emailMeRecover: "E-mail me a recovery link",
    autoNegative: "Automatic negative feedback",
    autoNegativeMessage:
      "The student receives this automatic negative feedback if you don't take any action within the set number of days.",
    amountOfDays: "Amount of days",
    amountOfMonth: "Amount of months",
    saveChanges: "Save changes",
    autoShortlist: "Automatic shortlist feedback",
    autoShortlistMessage:
      "The student receives this automatic shortlist feedback if you added them to favourites but did not invite or reject them within the set number of days.",
    periodOfEmployment: "Period of employment",
    organization: "Organization",
    role: "Role",
    whatDo: "What does the organization do?",
    whatRole: "What's your role in the team?",
    responsibilities: "Responsibilities",
    tools: "Tools",
    keyAchievment: "Key achievement",
    proudOf: "What are you proud of",
    yearsOld: "years old",
    checkYourEmail: "Check your e-mail 💌",
    emailRecoveryMessage:
      "If your account exists, an email will be sent with further instructions. Please click the link when you receive it to recover your password.",
    waitingForFeedback: "is waiting for your feedback",
    markAsRead: "Mark all as read",
    contacted: "Contacted",
    accepted: "Accepted",
    inProgress: "In progress",
    notInterested: "Not interested",
    r_score: "Realistic",
    i_score: "Investigative",
    a_score: "Artistic",
    s_score: "Social",
    e_score: "Enterprising",
    c_score: "Conventional",
    sendEmail: "Send email",
    clearData: "Clear data",
    information: "Information",
    preferences: "Preferences",
    sex: "Title",
    city: "City",
    mode: "Mode",
    degree: "Degree",
    fit: "Fit",
    male: "Mr",
    female: "Ms",
    online: "Online",
    dominantPersonality: "Personality",
    PL: "Polish",
    EN: "English",
    "PL,EN": "Polish, English",
    "EN,PL": "English, Polish",
    master: "Master",
    bachelor: "Bachelor",
    postgrad: "Postgraduate",
    major: "Major",
    majors: "Majors",
    Majors: "Majors",
    createMajor: "Create major",
    editMajor: "Edit major",
    majorInfo: "Major info",
    majorName: "Major name",
    majorSpecialization: "Major specialization",
    priceEuro: "Annual price for EU citizens 🇪🇺🇵🇱",
    priceNonEuro: "Annual price for non-EU citizens 🇺🇦🇧🇾🇹🇷",
    link: "Major link",
    changePassword: "Change password",
    newPassword: "New password",
    oldPassword: "Old password",
    repeatNewPassword: "Repeat password",
    oldPassWrong: "Old password is incorrect",
    differentPasswords: "Passwords don't match",
    changeLanguage: "Change language",
    Language: "Language",
    "Language:": "Language:",
    langOption_pl: "Polska",
    langOption_en: "English",
    language: "Study language",
    pl: "Polish 🇵🇱",
    en: "English 🇺🇸",
    nl: "Dutch 🇳🇱",
    Export: "Export",
    exportInfo: "Export students",
    fromDate: "From date",
    toDate: "To date",
    exportUseFilters: "Selected filters will be applied to the export.",
    format: "Format",
    Stop: "Stop",
    noNotifications: "No notifications yet",
    widgetLanguage: "Widget language",
    clicked: "Clicked",
    liked: "Liked",
    // Export column translations
    createdAt: "Submission date",
    name: "Name",
    lastName: "Last name",
    email: "Email",
    degreeType: "Degree type",
    assessmentLanguage: "Page language",
    studyLevel: "Study level",
    studyMode: "Study mode",
    alreadyStudent: "Already a student",
    newsletterAllowed: "Newsletter allowed",
    userActions: "User actions",
    expectedStartYear: "Expected start year",
    suggestedCourses: "Suggested courses",
    initialSuggestedCourses: "Initial suggested courses",
    Yes: "Yes",
    No: "No",
    // Dashboard / analytics
    analyticsTitle: "Analytics",
    loadingAnalytics: "Loading analytics…",
    loadingDashboard: "Loading dashboard…",
    loadingEmbed: "Loading PostHog dashboard…",
    refreshingDashboard: "Refreshing dashboard…",
    refreshing: "Refreshing",
    apply: "Apply",
    refresh: "Refresh",
    refreshDashboard: "Refresh dashboard",
    from: "From",
    to: "To",
    datePresets: "Date presets",
    last7Days: "Last 7 days",
    last30Days: "Last 30 days",
    last90Days: "Last 90 days",
    mtd: "Month to date",
    qtd: "Quarter to date",
    ytd: "Year to date",
    invalidDate: "Invalid date",
    dateRangeInvalid: "Choose a valid start and end date.",
    startBeforeEnd: "Start date must be before the end date.",
    fixDates: "Please fix the highlighted dates.",
    syncingRange: "Syncing date range",
    syncingFilters: "Updating dashboard filters…",
    rangeSynced: "Date range synced",
    syncFailed: "Could not sync the range",
    dashboardRefreshed: "Dashboard refreshed",
    embedFailed: "Failed to load dashboard",
    selectedRange: "Selected date range",
    embeddedDashboard: "Embedded dashboard",
  },
  pl: {
    languageName: "Polski",
    students: "Studenci",
    dashboard: "Analityka",
    settings: "Ustawienia",
    logout: "Wyloguj się",
    login: "Nazwa użytkownika",
    email: "E-mail",
    signIn: "Zaloguj się",
    signingIn: "Trwa logowanie...",
    search: "Szukaj",
    password: "Hasło",
    showPassword: "Pokaż hasło",
    hidePassword: "Ukryj hasło",
    authBackToSignIn: "Wróć",
    authConfirmTotp: "Uwierzytelnianie dwuetapowe",
    authCode: "Kod",
    authCodeRequired: "Wprowadź kod z aplikacji uwierzytelniającej",
    authIncorrectCredentials: "Nieprawidłowy adres e-mail lub hasło.",
    authMessages: {
      "An account with the given email already exists.":
        "Konto z tym adresem e-mail już istnieje.",
      "Confirm a Code": "Potwierdź kod",
      "Confirm Sign In": "Potwierdź logowanie",
      "Create account": "Utwórz konto",
      "Enter your password": "Wprowadź hasło",
      "Forgot Password": "Zapomniałeś hasła?",
      "Have an account? ": "Masz już konto? ",
      "Invalid password format": "Nieprawidłowy format hasła",
      "Invalid phone number format": "Nieprawidłowy format numeru telefonu",
      "Loading...": "Ładowanie...",
      "Lost your code? ": "Nie otrzymałeś kodu? ",
      "Network error": "Błąd sieci",
      "New Password": "Nowe hasło",
      "No account? ": "Nie masz konta? ",
      "Resend a Code": "Wyślij kod ponownie",
      "Reset password": "Zresetuj hasło",
      "Sign In with AWS": "Zaloguj przez AWS",
      "Sign Out": "Wyloguj się",
      "Sign Up": "Zarejestruj się",
      "User already exists": "Użytkownik już istnieje",
      "User does not exist": "Użytkownik nie istnieje",
      "Username cannot be empty": "Adres e-mail nie może być pusty",
      "Username/client id combination not found.":
        "Nie znaleziono kombinacji użytkownika i identyfikatora klienta.",
      "It may take a minute to arrive.": "Dostarczenie może potrwać chwilę.",
      "Your passwords must match": "Hasła muszą być identyczne",
      "Dismiss alert": "Zamknij alert",
      Submitting: "Wysyłanie",
      "Sign in to your account": "Zaloguj się na swoje konto",
      "Back to Sign In": "Powrót do logowania",
      "Change Password": "Zmień hasło",
      Changing: "Zmienianie",
      "Confirm Password": "Potwierdź hasło",
      "Confirm Sign Up": "Potwierdź rejestrację",
      "Confirm SMS Code": "Potwierdź kod SMS",
      Confirm: "Potwierdź",
      "Confirmation Code": "Kod potwierdzenia",
      Confirming: "Potwierdzanie",
      "Create a new account": "Utwórz nowe konto",
      "Create Account": "Utwórz konto",
      "Creating Account": "Tworzenie konta",
      "Enter your code": "Wprowadź swój kod",
      "Enter your email": "Wpisz swój adres e-mail",
      "Enter your phone number": "Wpisz swój numer telefonu",
      "Enter your username": "Wprowadź swój adres e-mail",
      "Forgot password?": "Zapomniałeś hasła?",
      "Forgot your password?": "Zapomniałeś hasła?",
      "It may take a minute to arrive": "Może to chwilę potrwać",
      Loading: "Ładowanie",
      "New password": "Nowe hasło",
      or: "albo",
      "Phone Number": "Numer telefonu",
      "Resend Code": "Wyślij kod ponownie",
      "Reset your Password": "Zresetuj hasło",
      "Send code": "Wyślij kod",
      "Send Code": "Wyślij kod",
      Sending: "Wysyłanie",
      "Setup TOTP": "Konfiguruj TOTP",
      "Sign In": "Logowanie",
      "Sign In with Amazon": "Zaloguj przez Amazon",
      "Sign In with Apple": "Zaloguj przez Apple",
      "Sign In with Facebook": "Zaloguj przez Facebook",
      "Sign In with Google": "Zaloguj przez Google",
      Skip: "Pomiń",
      Submit: "Wyślij",
      "Verify Contact": "Weryfikacja danych kontaktowych",
      Verify: "Zweryfikuj",
      "We Emailed You": "Wysłaliśmy Ci wiadomość e-mail",
      "We Sent A Code": "Wysłaliśmy kod",
      "We Texted You": "Wysłaliśmy Ci wiadomość SMS",
      "Your code is on the way. To log in, enter the code we emailed to":
        "Twój kod został wysłany. Aby się zalogować, wprowadź kod wysłany na adres e-mail",
      "Your code is on the way. To log in, enter the code we sent you":
        "Twój kod został wysłany. Aby się zalogować, wprowadź wysłany do Ciebie kod",
      "Your code is on the way. To log in, enter the code we texted to":
        "Twój kod został wysłany. Aby się zalogować, wprowadź kod wysłany w wiadomości SMS",
      "Account recovery requires verified contact information":
        "Odzyskanie konta wymaga zweryfikowanych danych kontaktowych",
    },
    notifications: "Powiadomienia",
    allStudents: "Wszyscy studenci",
    sortBy: "Sortuj według",
    universityName: "Nazwa uczelni",
    skills: "Umiejętności",
    MajorYouAppliedFor: "Kierunek, na który aplikujesz",
    activeFilters: "Aktywne filtry",
    clearAll: "Wyczyść wszystko",
    clear: "Wyczyść",
    new: "Nowy",
    invited: "Zaproszony",
    rejected: "Odrzucony",
    itemsSelected: "wybranych pozycji",
    invite: "Zaproś",
    shortlist: "Lista preferencji",
    reject: "Odrzuć",
    student: "Student",
    addToShortlist: "Dodaj do listy preferencji",
    education: "Wykształcenie",
    workPreferences: "Preferencje zawodowe",
    languages: "Języki",
    personalityTraits: "Cechy osobowości",
    isTheMaximumScore: "jest wynikiem maksymalnym",
    meaningOfTheTest: "Interpretacja testu",
    toolsAndSkills: "Narzędzia i umiejętności",
    advancedness: "Poziom zaawansowania",
    workExperience: "Doświadczenie zawodowe",
    less: "Mniej",
    more: "Więcej",
    vacancies: "Kierunki i specjalności",
    department: "Wydział",
    status: "Status",
    applied: "Złożył dokumenty",
    studentsApplied: "Zaaplikowano",
    draft: "Wersja robocza",
    closed: "Zamknięty",
    published: "Opublikowany",
    reverse: "Odwróć",
    rejectStudent: "Odrzuć studenta",
    chooseTemplate: "Wybierz szablon",
    title: "Tytuł",
    email: "E-mail",
    message: "Wiadomość",
    close: "Zamknij",
    open: "Otwórz",
    save: "Zapisz",
    sendMessage: "Wyślij wiadomość",
    optional: "Opcjonalnie",
    cc: "DW",
    fieldRequired: "To pole jest wymagane",
    MajorParameters: "Parametry kierunku",
    positionName: "Nazwa stanowiska",
    firmName: "Nazwa firmy",
    salary: "Wynagrodzenie (w PLN)",
    perYear: "Rocznie",
    perMonth: "Miesięcznie",
    brutto: "Brutto",
    netto: "Netto",
    workType: "Rodzaj pracy",
    fullTime: "Pełny etat",
    partTime: "Niepełny etat",
    office: "Biuro",
    remote: "Zdalnie",
    dontShowSalary: "Nie pokazuj wynagrodzenia",
    MajorDescription: "Opis kierunku",
    aboutUs: "O nas",
    description: "Opis",
    weOffer: "Oferujemy",
    studentRequirements: "Wymagania wobec studenta",
    addLanguage: "Dodaj język",
    skillsAndTech: "Umiejętności i technologie",
    enterSkill: "Wpisz umiejętność",
    requirements: "Wymagania",
    post: "Opublikuj",
    enterCity: "Wpisz miasto",
    helpSkills: "Wpisz wymagane umiejętności i/lub narzędzia",
    publish: "Opublikuj",
    delete: "Usuń",
    cancel: "Anuluj",
    deleteConfirmation: "Czy na pewno chcesz usunąć te elementy?",
    selected: "wybrano",
    undoAlert: "Tej operacji nie można cofnąć",
    clearConfirmation: "Czy na pewno chcesz wyczyścić formularz?",
    wrongCredentials: "Nieprawidłowy login lub hasło",
    defaultErrorMessage: "Wystąpił błąd. Spróbuj ponownie później.",
    personalInfo: "Dane osobowe",
    firstName: "Imię",
    lastName: "Nazwisko",
    companyName: "Nazwa firmy",
    recoverPassword: "Odzyskaj hasło",
    recoverPasswordMessage:
      "Podaj swój adres e-mail – jeśli konto istnieje, wyślemy link do odzyskania hasła.",
    yourEmail: "Twój e-mail",
    emailMeRecover: "Wyślij mi link do odzyskania hasła",
    autoNegative: "Automatyczna informacja zwrotna o odrzuceniu",
    autoNegativeMessage:
      "Student otrzyma tę automatyczną informację zwrotną, jeśli w określonej liczbie dni nie podejmiesz wobec niego żadnych działań.",
    amountOfDays: "Liczba dni",
    amountOfMonth: "Liczba miesięcy",
    saveChanges: "Zapisz zmiany",
    autoShortlist: "Automatyczna informacja zwrotna z listy preferencji",
    autoShortlistMessage:
      "Student otrzyma tę automatyczną informację zwrotną, jeśli dodasz go do ulubionych, ale w określonej liczbie dni nie zaprosisz go ani nie odrzucisz.",
    periodOfEmployment: "Okres zatrudnienia",
    organization: "Organizacja",
    role: "Stanowisko",
    whatDo: "Czym zajmuje się organizacja?",
    whatRole: "Jaka jest Twoja rola w zespole?",
    responsibilities: "Obowiązki",
    tools: "Narzędzia",
    keyAchievment: "Kluczowe osiągnięcie",
    proudOf: "Z czego jesteś dumny/dumna",
    yearsOld: "lat",
    checkYourEmail: "Sprawdź swoją skrzynkę 💌",
    emailRecoveryMessage:
      "Jeżeli konto istnieje, wyślemy instrukcje na podany adres e-mail. Kliknij w link w wiadomości, aby odzyskać hasło.",
    waitingForFeedback: "czeka na Twoją informację zwrotną",
    markAsRead: "Oznacz wszystko jako przeczytane",
    contacted: "Skontaktowano się",
    accepted: "Zaakceptowany",
    inProgress: "W trakcie aplikacji",
    notInterested: "Niezainteresowany",
    r_score: "Realistyczny",
    i_score: "Badawczy",
    a_score: "Artystyczny",
    s_score: "Społeczny",
    e_score: "Przedsiębiorczy",
    c_score: "Konwencjonalny",
    sendEmail: "Wyślij e-mail",
    clearData: "Wykasuj dane osobowe",
    information: "Informacja",
    preferences: "Preferencje",
    sex: "Zwrot grzecznościowy",
    widgetLanguage: "Język widgetu",
    city: "Miasto",
    mode: "Tryb studiów",
    degree: "Poziom studiów",
    fit: "Dopasowanie",
    male: "Pan",
    female: "Pani",
    online: "Online",
    dominantPersonality: "Osobowość",
    PL: "Polski",
    EN: "Angielski",
    "PL,EN": "Polski, angielski",
    "EN,PL": "Angielski, polski",
    fulltime: "Stacjonarne",
    parttime: "Zaoczne",
    postgrad: "Podyplomowe",
    "fulltime,parttime": "Stacjonarne, zaoczne",
    "parttime,fulltime": "Zaoczne, stacjonarne",
    master: "Magister",
    bachelor: "Licencjat",
    major: "Kierunek",
    majors: "Kierunki",
    Majors: "Kierunki",
    createMajor: "Nowa specjalność",
    editMajor: "Edytuj specjalność",
    majorInfo: "Informacje o specjalności",
    majorName: "Nazwa kierunku",
    majorSpecialization: "Nazwa specjalności",
    priceEuro: "Roczna cena za studia dla obywateli UE 🇪🇺🇵🇱",
    priceNonEuro: "Roczna cena za studia dla obywateli spoza UE 🇺🇦🇧🇾🇹🇷",
    link: "Link do specjalności lub kierunku",
    changePassword: "Zmień hasło",
    newPassword: "Nowe hasło",
    oldPassword: "Stare hasło",
    repeatNewPassword: "Powtórz nowe hasło",
    oldPassWrong: "Stare hasło jest niepoprawne",
    differentPasswords: "Hasła nie są zgodne",
    changeLanguage: "Zmień język",
    Language: "Język",
    "Language:": "Język:",
    langOption_pl: "Polska",
    langOption_en: "Angielski",
    language: "Język studiów",
    pl: "Polski 🇵🇱",
    en: "Angielski 🇺🇸",
    nl: "Niderlandzki 🇳🇱",
    Export: "Eksportuj",
    exportInfo: "Eksportuj studentów",
    fromDate: "Data od",
    toDate: "Data do",
    exportUseFilters: "Wybrane filtry zostaną zastosowane przy eksporcie.",
    format: "Format",
    Stop: "Zatrzymaj",
    noNotifications: "Brak powiadomień",
    clicked: "Kliknięte",
    liked: "Polubione",
    // Export column translations
    createdAt: "Data zgłoszenia",
    name: "Imię",
    degreeType: "Typ stopnia",
    assessmentLanguage: "Język strony",
    studyLevel: "Poziom studiów",
    studyMode: "Tryb studiów",
    alreadyStudent: "Już student",
    newsletterAllowed: "Zgoda na newsletter",
    userActions: "Akcje użytkownika",
    expectedStartYear: "Oczekiwany rok rozpoczęcia",
    suggestedCourses: "Sugerowane kursy",
    initialSuggestedCourses: "Początkowo sugerowane kursy",
    Yes: "Tak",
    No: "Nie",
    // Dashboard / analytics
    analyticsTitle: "Analityka",
    loadingAnalytics: "Wczytywanie analityki…",
    loadingDashboard: "Wczytywanie panelu…",
    loadingEmbed: "Wczytywanie panelu PostHog…",
    refreshingDashboard: "Odświeżanie panelu…",
    refreshing: "Odświeżanie",
    apply: "Zastosuj",
    refresh: "Odśwież",
    refreshDashboard: "Odśwież panel",
    from: "Od",
    to: "Do",
    datePresets: "Predefiniowane zakresy",
    last7Days: "Ostatnie 7 dni",
    last30Days: "Ostatnie 30 dni",
    last90Days: "Ostatnie 90 dni",
    mtd: "Od początku miesiąca",
    qtd: "Od początku kwartału",
    ytd: "Od początku roku",
    invalidDate: "Nieprawidłowa data",
    dateRangeInvalid: "Wybierz prawidłową datę początkową i końcową.",
    startBeforeEnd: "Data początkowa musi być wcześniejsza niż końcowa.",
    fixDates: "Popraw oznaczone daty.",
    syncingRange: "Synchronizowanie zakresu dat",
    syncingFilters: "Aktualizowanie filtrów panelu…",
    rangeSynced: "Zakres dat zsynchronizowany",
    syncFailed: "Nie udało się zsynchronizować zakresu",
    dashboardRefreshed: "Panel odświeżony",
    embedFailed: "Nie udało się załadować panelu",
    selectedRange: "Wybrany zakres dat",
    embeddedDashboard: "Osadzony panel",
  },
};
